import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import TrainingForm from '../TrainingForm';

const AddTraining = ({ state, dispatch, updateFieldCreator, errors, createTraining, removeError }) => {
  const { t } = useTranslation();

  return (
    <TrainingForm
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      errors={errors}
      removeError={removeError}
      onSubmit={createTraining}
      heading={t('page.ma.cpdManagement.trainings.addTraining')}
    />
  );
};

AddTraining.propTypes = {
  state: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  updateFieldCreator: PropTypes.func.isRequired,
  errors: PropTypes.object,
  createTraining: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
};

AddTraining.defaultProps = {
  errors: {},
};

export default AddTraining;
